import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://hopfitness.ci/api',
    headers: {
        'Content-Type': 'application/json'
    }
});

// Intercepteur pour injecter le token d'accès
api.interceptors.request.use(
    (config) => {
        const token = useAuthStore.getState().accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Intercepteur pour gérer l'expiration du token et le rafraîchissement
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Si l'erreur est 401 (Non autorisé) et qu'on n'a pas déjà essayé de rafraîchir
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = useAuthStore.getState().refreshToken;

            if (refreshToken) {
                try {
                    const res = await axios.post(`${api.defaults.baseURL}/auth/refresh-token`, { token: refreshToken });
                    
                    const { accessToken: newAccess, refreshToken: newRefresh } = res.data;
                    
                    useAuthStore.getState().setTokens(newAccess, newRefresh);
                    
                    // Réessayer la requête originale avec le nouveau token
                    originalRequest.headers.Authorization = `Bearer ${newAccess}`;
                    return axios(originalRequest);
                } catch (refreshError) {
                    useAuthStore.getState().logout();
                    if (window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                        window.location.href = '/login';
                    }
                    return Promise.reject(refreshError);
                }
            } else {
                useAuthStore.getState().logout();
                if (window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                    window.location.href = '/login';
                }
            }
        }
        
        return Promise.reject(error);
    }
);

export default api;
